export class Option {
	id = null;
	name = null;
	values = [];

	constructor(data) {
		Object.assign(this, data);
	}

	isSame(otherOption) {
		return (
			this.id == otherOption.id &&
			this.name == otherOption.name
		);
	}
} 